import type { RootState } from '@core/redux/interface';
import { elementSelectors } from '@elements/redux';
import { PointElement, SplineElement } from '@elements/types';
import { useTheme } from '@mui/material';
import { SelectionArea } from '@viewer3D/components/SelectionArea';
import { Object3dNames } from '@viewer3D/types';
import { useSelector } from 'react-redux';
import { setSelectedPointIds, setSelectedSplineElements } from './state';

const getUniqueElements = (elements: SplineElement[] | PointElement[]) => {
  const uniqueElementsMap = new Map();
  elements.forEach((element) => {
    if (element && element.id) {
      uniqueElementsMap.set(element.id, element);
    }
  });

  return Array.from(uniqueElementsMap.values());
};

export const ElementSelectionArea = () => {
  const theme = useTheme();

  const state = useSelector((state: RootState) => state);

  return (
    <SelectionArea
      style={{
        backgroundColor: `${theme.palette.primary.main}`,
        opacity: 0.3,
        position: 'fixed',
      }}
      onSelectionChanged={(objs) => {
        if (objs.length === 0) return;

        const elementPoints = objs
          .filter((obj) => obj.name.includes(Object3dNames.ElementPoint))
          .map(({ name }) => name.split(':')[1]);

        const allSplineElementsInPoints = elementPoints.flatMap((pointId) =>
          elementSelectors.selectByPointId(pointId)(state),
        );
        const splineElementsInPoints = getUniqueElements(allSplineElementsInPoints);
        setSelectedSplineElements(splineElementsInPoints);
        setSelectedPointIds(elementPoints);
      }}
    />
  );
};
